module.exports = __webpack_public_path__ + "media/images/about-logo-ata-1dee6fe0119c96da6f71716cc730c861.png";